import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { L1PortfoliosEdit } from "./edit";
import { L1PortfoliosNew } from "./new";
import { L1PortfoliosTable } from "./table";
export default function L1Portfolios() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Portefeuilles");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<L1PortfoliosEdit />} />
      <Route index element={<L1PortfoliosTable />} />
      <Route path="/new" element={<L1PortfoliosNew />} />
    </Routes>
  );
}
